import SubstrateSearchResponse, {
    SearchResultSet,
} from '../../../data/schema/SubstrateSearchResponse';

export default function getSearchResultSet(responseBody: SubstrateSearchResponse): SearchResultSet {
    if (
        responseBody &&
        responseBody.EntitySets &&
        responseBody.EntitySets[0] &&
        responseBody.EntitySets[0].ResultSets &&
        responseBody.EntitySets[0].ResultSets[0]
    ) {
        return responseBody.EntitySets[0].ResultSets[0];
    }

    return null;
}
